
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/events/new",
      function () {
        return require("private-next-pages/admin/events/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/events/new"])
      });
    }
  